export default __webpack_public_path__ + "images/whatsApp.svg?efe6e7030896143b80ce9d9b376990b4";